import React from 'react';
import { useAppSelector } from '../store/store';
import { languageSelector, sectorsSelector, selectedDeliveryProviderSelector, selectedSectorSelector } from '../service/common.slice';
import "./SectorSelector.sass";
import { cartSelector } from '../service/checkout.slice';
import { IconCheckCircle } from '../common/Icons';
import { getDeliveryName } from '../service/utils';

interface SectorSelectorProps {
    onContainerClick: () => void;
}

export const SectorSelector: React.FC<SectorSelectorProps> = ({ onContainerClick }) => {
    const cart = useAppSelector(cartSelector);
    const sector = useAppSelector(selectedSectorSelector);
    const sectors = useAppSelector(sectorsSelector);
    const selectedDeliveryProvider = useAppSelector(selectedDeliveryProviderSelector);
    const lang = useAppSelector(languageSelector);

    if (!cart) return null;

    const deliveryName = getDeliveryName(selectedDeliveryProvider)(lang);
    
    if (sectors?.length === 0) {
        return null;
    }

    return (
        <div className="sector-selector-container" onClick={onContainerClick}>
            <div className="sector-selector-contents">
                <div className="sector-selector-contents-inner">
                    <div className="sector-selector">
                        <div style={{flexShrink:"0"}}>
                            <IconCheckCircle className="icon"/>
                        </div>
                        <div style={{flexGrow:"1", textAlign: "left"}}>
                            <div>{sector?.title}</div>
                            <div style={{fontWeight: 'bold'}}>{deliveryName}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

